export const FETCHING_ITEMS = "FETCHING_CINEMA_SHOWTIMES";
export const FETCHED_ITEMS = "FETCHED_CINEMA_SHOWTIMES";
export const RECEIVED_ITEMS = "RECEIVED_CINEMA_SHOWTIMES";
export const FETCHING_MORE_ITEMS = "FETCHING_MORE_CINEMA_SHOWTIMES";
export const FETCHED_MORE_ITEMS = "FETCHED_MORE_CINEMA_SHOWTIMES";
export const RECEIVED_MORE_ITEMS = "RECEIVED_MORE_CINEMA_SHOWTIMES";
export const UPDATED_FILTERS = "UPDATED_CINEMA_SHOWTIMES_FILTERS";
export const REPLACED_FILTERS = "REPLACED_CINEMA_SHOWTIMES_FILTERS";
